import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
    createMigrate,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import productReducer from './slices/product-slice';
import currencyReducer from "./slices/currency-slice";
import cartReducer from "./slices/cart-slice";
import compareReducer from "./slices/compare-slice";
import wishlistReducer from "./slices/wishlist-slice";
import userReducer from "./slices/user-slice";
import settingsReducer from "./slices/settings-slice";

// Migration: bump version to 2 to force a clean state on all devices
// This fixes the "clear cookies to make it work" issue on mobile
const migrations = {
    2: (state) => {
        // Return a clean state — wipes any corrupted persisted data
        return {
            currency: state?.currency || undefined,
            // cart and wishlist start fresh (they are not blacklisted but may be stale)
            cart: { cartItems: [], loading: false, error: null, totalItems: 0, subtotal: 0 },
            compare: { compareItems: [] },
            wishlist: { wishlistItems: [] },
            settings: undefined,
        };
    },
};

const persistConfig = {
    key: "artote",
    version: 2,  // bumped from 1.1 → 2 to trigger migration and clear stale state
    storage,
    blacklist: ["product", "user"],
    migrate: createMigrate(migrations, { debug: false }),
}

export const rootReducer = combineReducers({
    product: productReducer,
    currency: currencyReducer,
    cart: cartReducer,
    compare: compareReducer,
    wishlist: wishlistReducer,
    user: userReducer,
    settings: settingsReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    FLUSH,
                    REHYDRATE,
                    PAUSE,
                    PERSIST,
                    PURGE,
                    REGISTER,
                ],
            },
        }),
});

export const persistor = persistStore(store);
